import React from "react";

function ArrowUp() {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 220 400'>
            <defs>
                <linearGradient
                    id='linearGradient4126'
                    x1='182'
                    x2='186'
                    y1='8'
                    y2='204'
                    gradientTransform='translate(-74.474 692.02)'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0' stopColor='#d5e5ff'></stop>
                    <stop offset='1' stopColor='#d5e5ff' stopOpacity='0'></stop>
                </linearGradient>
                <linearGradient
                    id='linearGradient4129'
                    x1='148'
                    x2='186'
                    y1='351'
                    y2='207'
                    gradientTransform='translate(-74.474 692.02)'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0' stopColor='#2a7fff'></stop>
                    <stop offset='1' stopColor='#2a7fff' stopOpacity='0'></stop>
                </linearGradient>
                <linearGradient
                    id='linearGradient4132'
                    x1='384.35'
                    x2='59.452'
                    y1='938.18'
                    y2='943.62'
                    gradientTransform='scale(-1 1) rotate(-87.455 -1.774 1060.255)'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0' stopColor='#0000d4'></stop>
                    <stop offset='1' stopColor='#005'></stop>
                </linearGradient>
                <linearGradient
                    id='linearGradient4141'
                    x1='111.2'
                    x2='112.74'
                    y1='761.24'
                    y2='972.05'
                    gradientTransform='translate(0 -16)'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop offset='0' stopColor='#55f'></stop>
                    <stop offset='1' stopColor='#00a' stopOpacity='0'></stop>
                </linearGradient>
            </defs>
            <g transform='translate(0 -652.36)'>
                <g>
                    <path
                        fill='#00112b'
                        stroke='#00112b'
                        strokeWidth='9'
                        d='M39.841 846.46c.016.586.094 1.05.245 1.343 1.399 2.79 21.745-10.709 36.316-11.525.199 47.539-15.3 186.76-11.77 195.29 2.305 5.571 26.105-12.083 50.321-14.628 24.216-2.544 48.847 10.022 50.832 3.924 3.04-9.337-20.03-145.53-22.438-192.8 14.52-2.754 35.394 3.004 36.63-.11 4.165-10.487-63.626-156.97-72.503-155.88-8.6 1.056-68.082 156.21-67.634 174.39z'
                        color='#000'
                    ></path>
                    <path
                        fill='url(#linearGradient4132)'
                        d='M39.805 844.25c.016.586.094 1.05.245 1.343 1.399 2.79 21.745-10.709 36.316-11.525.199 47.539-15.3 186.76-11.77 195.29 2.305 5.571 26.105-12.083 50.322-14.628 24.216-2.544 48.847 10.022 50.832 3.924 3.04-9.337-20.03-145.53-22.438-192.8 14.52-2.754 35.394 3.004 36.63-.11 4.165-10.487-63.626-156.97-72.503-155.88-8.6 1.056-68.082 156.21-67.634 174.39z'
                        color='#000'
                    ></path>
                    <path
                        fill='url(#linearGradient4141)'
                        fillRule='evenodd'
                        d='M109.19 698.91a1571.16 1571.16 0 00-29.953 74.068c14.318-6.39 28.636-12.777 42.952-19.162a57912.805 57912.805 0 01-23.319 69.737c8.975-3.457 17.949-6.911 26.922-10.363a2975.145 2975.145 0 01-40.941 148.63l-3.136 18.51 22.832.775 1.934-18.362a2955.099 2955.099 0 0121.603-151.61 65183.4 65183.4 0 01-27.17 10.707c7.42-22.982 14.861-45.973 22.321-68.972-14.42 6.491-28.839 12.98-43.257 19.466a1534.868 1534.868 0 0029.211-73.42z'
                    ></path>
                    <path
                        fill='url(#linearGradient4129)'
                        d='M132.53 914.02c-25.216 0-47.923 14.999-63.813 38.938-3.165 38.92-5.793 72.376-4.125 76.406 2.306 5.571 26.128-12.081 50.344-14.625 24.216-2.544 48.828 10.004 50.812 3.906 1.747-5.367-5.126-52.687-11.75-100.91-6.865-2.432-14.062-3.719-21.469-3.719z'
                        color='#000'
                    ></path>
                    <path
                        fill='url(#linearGradient4126)'
                        d='M107.43 669.87c-8.6 1.056-68.073 156.19-67.625 174.38.016.586.099 1.05.25 1.344.007.013.024.018.031.031a227.57 227.57 0 0121.406-7.844c4.029-1.524 8.174-2.82 12.062-3.406 20.958-5.378 43.752-8.344 67.47-8.344.763 0 1.52.025 2.28.032-.003-.06.003-.129 0-.188 14.52-2.754 35.388 2.988 36.625-.125 4.166-10.487-63.623-156.96-72.5-155.88z'
                        color='#000'
                    ></path>
                </g>
                <path
                    fill='none'
                    stroke='#000'
                    strokeWidth='1'
                    d='M116.6 88.031c-.824.403-1.524 1.019-2.188 1.651-.966.92-1.843 1.929-2.688 2.96-2.36 2.883-4.46 5.966-6.494 9.087-5.356 8.222-10.169 16.789-14.74 25.472 0 0 0 0 0 0-4.303 8.171-8.429 16.449-11.918 24.999 0 0 0 0 0 0-1.134 2.779-2.244 5.581-2.964 8.495-.208.846-.401 1.706-.394 2.577v0c.002.266.023.537.117.787.065.173.177.338.343.42 2.886 1.444 6.245 1.705 9.45 1.337 3.843-.44 7.553-1.679 11.124-3.162 8.31-3.45 15.976-8.261 23.647-12.965 0 0 0 0 0 0 3.544-2.173 7.08-4.361 10.716-6.376 2.819-1.562 5.69-3.086 8.773-4.02h0c1.098-.332 2.23-.587 3.376-.591.889-.003 1.8.166 2.551.64.757.478 1.293 1.251 1.614 2.087.455 1.185.563 2.476.563 3.746v0c0 2.279-.748 4.494-1.637 6.593-1.196 2.82-2.736 5.481-4.37 8.072-4.138 6.563-8.914 12.697-13.678 18.82-5.008 6.439-10.106 12.81-14.84 19.454-2.051 2.879-4.037 5.81-5.82 8.862 0 0 0 0 0 0-1.437 2.458-2.77 4.996-3.67 7.697-.12.36-.205.765-.06 1.116.119.286.408.467.707.549 1.079.296 2.227-.037 3.313-.308h0c1.764-.44 3.482-1.051 5.188-1.683 2.106-.78 4.19-1.62 6.272-2.462 4.183-1.695 8.342-3.466 12.63-4.875 1.563-.514 3.145-1.002 4.776-1.22h0c.549-.072 1.108-.117 1.657-.043.378.05.768.162 1.038.432h0c.59.59.814 1.451.95 2.274.21 1.276.185 2.579.106 3.87-.243 3.935-1.049 7.815-1.922 11.66-2.536 11.172-6.008 22.11-9.574 32.996 0 0 0 0 0 0-3.78 11.538-7.803 22.995-11.883 34.43h0c-1.6 4.485-3.213 8.966-4.808 13.453-1.021 2.875-2.06 5.745-2.985 8.653'
                ></path>
            </g>
        </svg>
    );
}

export default React.memo(ArrowUp);
